<template>
    <div class="pre-calibration-info">
        <div class="title">
            {{ $t('nBox.preCalibrationInfo') }}
        </div>
        <div class="scores">
            <div>
                <span class="axis-title">{{ $t('nBox.xAxis') + ':' }}</span>
                <span>{{ scores.x }}</span>
            </div>
            <div>
                <span class="axis-title">{{ $t('nBox.yAxis') + ':' }}</span>
                <span>{{ scores.y }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        scores: {
            type: Object,
            required: true,
        },
    },
}
</script>
<style lang="scss" scoped>
.pre-calibration-info {
    margin-bottom: 10px;

    .title {
        color: #929292;
        font-size: 12px;
        text-transform: uppercase;
    }

    .scores {
        display: flex;
        justify-content: space-around;
        padding: 5px;
        border-radius: 5px;
        border: 1px solid #e4e7ea;

        .axis-title {
            font-weight: bold;
            margin-right: 10px;
        }
    }
}
</style>
